export default '__LINK__'